export const normalisePathname = (pathname: string | null) => {
  if (!pathname) return '/';
  let finalPathname = pathname;
  switch (finalPathname) {
    case '/cv':
    case '/lcv':
      return '/';
    default:
      if (finalPathname.indexOf('/cv') == 0) {
        finalPathname = finalPathname.replace('/cv', '');
      }
      if (finalPathname.indexOf('/lcv') == 0) {
        finalPathname = finalPathname.replace('/lcv', '');
      }
  }

  return finalPathname;
};
